import * as React from 'react';
export const IcSeismicSensor = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M5 14.73h2.21c.08 0 .15-.04.18-.11l1.27-2.55c.08-.17.33-.15.38.03l2 6.73c.06.19.32.2.39.01l3.45-9.73c.07-.19.34-.18.39.02l1.35 5.44c.02.09.11.16.2.16h2.17'
      stroke='currentColor'
      strokeWidth={2}
      strokeMiterlimit={10}
      strokeLinecap='round'
    />
    <path
      d='M14.38 2.58c-.11-.08-.23-.14-.36-.18A10.01 10.01 0 002.07 8.34c-.1.25-.09.52.01.77.11.24.3.44.55.53.25.1.52.09.77-.01.24-.11.44-.3.53-.55a8.022 8.022 0 013.87-4.2 7.979 7.979 0 015.68-.55c.24.06.49.04.71-.07.12-.06.24-.14.33-.24.09-.1.16-.22.2-.35.04-.13.05-.26.04-.4-.01-.13-.06-.26-.12-.38a.942.942 0 00-.26-.3v-.01z'
      fill='currentColor'
    />
    <path
      d='M8.26 5.79a5.938 5.938 0 00-2.69 2.69c-.06.12-.09.25-.1.38 0 .13 0 .26.05.39a1.034 1.034 0 00.51.58c.24.12.51.13.77.05a1.034 1.034 0 00.58-.51C7.77 8.6 8.4 7.98 9.17 7.6c.77-.38 1.65-.51 2.49-.35a.994.994 0 001.17-.79.994.994 0 00-.79-1.17c-1.28-.24-2.6-.05-3.77.53l-.01-.03z'
      fill='currentColor'
    />
  </svg>
);
